import type { LicenceProvenance } from "@xop/dashboard-shared"

/**
 * Who created or issued a licence, in words — shared by the two surfaces that
 * say it: the reseller profile's Licences tab and the customer profile's
 * Licences tab (2026-09-15).
 *
 * PURE: it renders nothing. Both callers decide whether the viewer may see a
 * reseller's name at all (the customer tab through `<ResellerOnly>`), and
 * crm-api already omits `createdBy` / `issuedBy` behind the reseller wall.
 */

/** The reseller by name, "XOP" for staff, nothing when unrecorded — a licence
 * from before provenance existed (2026-09-15) must not have one invented. */
export function licenceActorName(provenance: LicenceProvenance | undefined): string | null {
  if (!provenance) return null
  return provenance.kind === "reseller" ? provenance.reseller?.name ?? "Reseller" : "XOP"
}

/** "Sep 10, 2026" from a date or a timestamp; null when absent or unreadable. */
export function formatLicenceDate(value: string | null | undefined): string | null {
  if (!value) return null
  const d = new Date(value.length === 10 ? `${value}T00:00:00` : value)
  return Number.isNaN(d.getTime())
    ? null
    : d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
}
